import fetchServer from "../../../fetchServer";

export default async function getChangeRequests(params, cancelToken) {
  const {
    limit = 0,
    offset = 0,
    searchBy,
    keyword,
    filterBy,
    filterValue,
  } = params || {};

  let result = {
    return: 0,
    msg: "Failed fetching change requests",
    data: [],
  };

  // build optional query params
  const searchQuery =
    searchBy && keyword
      ? `&searchBy=orderId&keyword=${encodeURIComponent(keyword)}`
      : "";

  const filterQuery =
    filterBy && filterValue
      ? `&filterBy=${encodeURIComponent(
          filterBy
        )}&filterValue=${encodeURIComponent(filterValue)}`
      : "";

  await fetchServer({
    method: "GET",
    url: `/product/v1/changeBooking/change?populate=account&populate=flightBooking&limit=${limit}&offset=${offset}${searchQuery}${filterQuery}`,
    cancelToken,
  })
    .then((res) => {
      if (res?.status === 200) {
        result = {
          return: 1,
          msg: "Successful",
          data: res.data?.data || [],
        };
      } else if (res?.data?.error) {
        result.msg = res.data.error;
      }
    })
    .catch((err) => {
      console.log(err.message, err);
      if (err.message === "Network Error!") {
        result.msg = "Network Error!";
        result.error = "Please check your connection.";
      }
    });

  return result;
}
